const dom = {
  label: '.js-variant',
  atc: '.js-atc'
};

const changePrice = (price, comparePrice) => {
  const priceFields = document.querySelectorAll('.pdp__price'),
    compareField = document.querySelectorAll('.js-compare'),
    saveField = document.querySelectorAll('.js-save');
  priceFields.forEach((el) => (el.innerHTML = `$${price}`));
  if (comparePrice && compareField) {
    compareField.forEach((el) => (el.innerHTML = `$${comparePrice}`));
    saveField.forEach((el) => (el.innerHTML = `$${(comparePrice - price).toFixed(2)}`));
  }
}

const variantSelector = () => {
  const variantInputs = document.querySelectorAll(dom.label);
  const atc = document.querySelector(dom.atc);
  if (!variantInputs) return;
  variantInputs.forEach((label) => {
    label.addEventListener('click', (e) => {
      const variantPrice = e.currentTarget.getAttribute('data-variant-price'),
        priceCompare = e.currentTarget.getAttribute('data-variant-compare');
      if ( e.currentTarget.classList.contains('disabled')) {
        atc.setAttribute('disabled', 'disabled');
        atc.textContent = "Sold out"
      } else {
        atc.removeAttribute('disabled');
        atc.textContent = "Add to cart";
      }
      changePrice(variantPrice, priceCompare);
    });
  });
};

export const init = () => {
  variantSelector();
};
